import { render } from "./CreateOtherWorkType.vue?vue&type=template&id=e77ba7a8"
import script from "./CreateOtherWorkType.vue?vue&type=script&lang=js"
export * from "./CreateOtherWorkType.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__